import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '@env/environment';
import { SKIP_API_PREFIX } from '../http-context';

export const apiPrefixInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_API_PREFIX)) {
        return next(request);
    }

    if (!/^https?:/i.test(request.url)) {
        request = request.clone({ url: environment.serverUrl + request.url });
    }

    return next(request);
};
